module.exports = __webpack_public_path__ + "nm-icons_5f32cf48dca30120ef8d1e688ab84243.ttf?8f5e6600b683724d3b20fa02405ddf20";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_5f32cf48dca30120ef8d1e688ab84243.ttf
// module id = 1297
// module chunks = 20